import type { FC } from 'react';
import React from 'react';

import { isTouchDevice } from '../../helpers/is-touch-device';

import type { TBannerLink } from './models';

export const SubsectionLink: FC<TBannerLink> = ({
    BannerLink,
    DataLayer,
    analytics,
    hasDropDown,
    link = '#',
    onEnter,
    onLeave,
    styles,
    title,
}) => {
    let className = styles.bottomRowBasic;

    if (hasDropDown) {
        className = styles.bottomRow;
    }

    /** Фикс для планшетов, выпадающие списки должны открываться
     * но переход по ссылке не должен происходит
     * TODO: в рамках задачи ALFABANKRU-34331 пересмотр UX виджета */
    const preventClick = hasDropDown && isTouchDevice;

    return (
        <span
            className={className}
            onBlur={onLeave}
            onFocus={onEnter}
            onMouseLeave={onLeave}
            onMouseOver={onEnter}
        >
            <DataLayer data={analytics}>
                <BannerLink link={preventClick ? undefined : link} title={title}>
                    {title}
                </BannerLink>
            </DataLayer>
        </span>
    );
};
